<template>
    <button class="btn btn-link" 
        type="button"
        @click.prevent="e => $emit('click', e)"
        :disabled="disabled"
        :title="title">
        <i :class="`fa fa-${icon}`" v-if="Boolean(icon)" /> {{ label }}
    </button>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        icon: {
            type: String,
            required: false,
            default: 'trash',
        },
        label: {
            type: String,
            required: false,
            default: null,
        },
        title: {
            type: String,
            required: false,
            default: 'Hapus',
        },
    }
}
</script>